import { usePlutoApiQuery } from 'hooks/useQuery/plutoApi';
import { GET_SITES } from 'pages/Operations/queries';
import { Outlet, useParams } from 'react-router';

const SITES_QUERY_POLLING_INTERNAL_SECONDS = 10;

export const OperationsOverview = () => {
  const { company, site } = useParams();
  const { data } = usePlutoApiQuery(GET_SITES, {
    variables: { companyId: company },
    pollInterval: SITES_QUERY_POLLING_INTERNAL_SECONDS * 1000,
    notifyOnNetworkStatusChange: true,
  });

  return (
    <div>
      <Outlet context={{ data }} />
    </div>
  );
};
